import { create } from 'zustand'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

interface Toast {
  id: string
  message: string
  type: ToastType
}

interface ToastStore {
  current: Toast | null
  showToast: (message: string, type?: ToastType) => void
  dismiss: () => void
}

let dismissTimer: ReturnType<typeof setTimeout> | undefined

export const useToastStore = create<ToastStore>((set) => ({
  current: null,

  showToast: (message, type = 'info') => {
    if (dismissTimer) clearTimeout(dismissTimer)
    const id = crypto.randomUUID()
    set({ current: { id, message, type } })
    dismissTimer = setTimeout(() => {
      set((s) => (s.current?.id === id ? { current: null } : s))
    }, 4000)
  },

  dismiss: () => {
    if (dismissTimer) clearTimeout(dismissTimer)
    set({ current: null })
  },
}))
